import { AiFillFile, AiFillFileImage, AiFillFileExcel, AiFillFilePdf, AiFillFileText, AiFillFilePpt, AiFillFileWord, AiFillFileMarkdown, AiFillFileZip, AiFillFileUnknown} from 'react-icons/ai';

const helpers = {

    mimetype_to_icon: (mimetype) => {

        const match = (array) => {
            
            return array.find(item => mimetype.includes(item))
        }

        if (match(["png", "jpeg", "gif", "bmp",  "jpg"])) return <AiFillFileImage color='#28AEEA' />
        if (match(["pdf"])) return <AiFillFilePdf color="#F76768" />
        if (match(["txt"])) return <AiFillFileText />
        if (match(["xls", "xlsx"])) return <AiFillFileExcel color="#3A9D3F" />
        if (match(["ppt", "ppt", "ppsx"])) return <AiFillFileExcel color="#3A9D3F" />
        if (match(["doc", "docx", "odt"])) return <AiFillFileWord color="#2B5795" />
        if (match(["md"])) return <AiFillFileMarkdown />
        if (match(["zip"])) return <AiFillFileZip />
    
        if (mimetype.length === 0) return <AiFillFileUnknown />
    
        return <AiFillFile />
    },

    getPath (id, folders) {
        let folder = folders.find(item => item.id === id);
        if (!folder) return [];

        let path = [folder];
        while (folder) {
            folder = folders.find(item => item.id === folder.folders_id);
            if (folder) path = [folder, ...path]
        }
        return path;
    },

    getDate(date = new Date()) {
        return date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate();
    }

}

export default helpers;